import * as z from "zod/v4";

export const participantSchema = z.object({
  id: z.uuid(),
  full_name: z.string(),
  speaker_id: z.string(),
  created_at: z.iso.datetime(),
});
